'use client';

import { useSelector } from 'react-redux';
import Conditional from '@next-app/components/Conditional';
import SkeletonUI from '@next-app/components/Skeleton/Skeleton';
import {
  selectRewardsInfo,
  selectCommerceItems,
  selectIsCheckoutDetailsLoaded,
  selectLoyaltyInfo,
} from '@next-app/lib/features/checkout/CheckoutSelector';
import RewardsMessage from '@next-app/components/shared/RewardsMessage/RewardsMessage';

const CheckoutRewardsMessage = () => {
  // selectors
  const cartItems = useSelector(selectCommerceItems);
  const isCheckoutDetailsLoaded = useSelector(selectIsCheckoutDetailsLoaded);
  const { isRewardsMember } = useSelector(selectLoyaltyInfo) || {};
  const { totalPoints } = useSelector(selectRewardsInfo) || {};

  return (
    <>
      <Conditional if={!isCheckoutDetailsLoaded}>
        <SkeletonUI width={'100%'} height={30} />
      </Conditional>
      <Conditional if={isCheckoutDetailsLoaded}>
        <RewardsMessage
          cartItems={cartItems}
          isRewardsMember={isRewardsMember}
          totalPoints={totalPoints}
          isCheckout={true}
        />
      </Conditional>
    </>
  );
};

export default CheckoutRewardsMessage;
